module.exports = __webpack_public_path__ + "img/Ketekunan-Value.975ed093.png";